import "./CategoryPage.scss";
import * as React from "react";
import {useNavigate} from "react-router-dom";

import {Context} from '../../../context/dataStore';
import {Context_role} from "../../../context/rolesStore";
import {ADMIN_ROLE, EM_ROLE} from "../../../constants/global";
import { BFCP_LIVE, BFCP_HE_LOCK, ANNOUNCEMENT,CATEGORY_REMINDER } from "../../../constants/reminder";
import {AnimatedEllipsis} from "../../../components";
import {categoryReducer} from "../../../components/Reducers/index";
import RightPanel from "./RightPanel";
import AlertBar from "./AlertBar";

import SideBar from "./SideBar";
import ProcessModal from "./ProcessModal";
import {marked} from 'marked';
import WhatsNewModal from "./WhatsNewModal";
import { FeatureFlags } from "../../../services/featureflag/featureflags";
import { updateFeatureFlag } from "../../../services/featureflag/featureflagservice";

const CategoryPage = () => {
  // getting data from context
  const {getCategory, dispatch, getReminderDescription,  state: {reminderData,metaDataAboutUser, orgData, featureFlagStatus}} = React.useContext(Context);
  const {state: {newroles} } = React.useContext(Context_role);
  let navigate = useNavigate();
  
  //is bfcp live
  const [is_BCFP_LIVE, set_BCFP_LIVE] = React.useState("");
  //is bfcp lock
  const [is_BCFP_HE_LOCK, set_BCFP_HE_LOCK] = React.useState("");
  //used to set up loader
  const [loading, setLoading] = React.useState(false);

  //setting up useReducers
  const DEFAULT_STATE = {categoryData: [], highpriorityStatus: false, cdsStatus: false, errorMessage: "", publishCatId: "", publishError: []};
  const [state, dispatcher] = React.useReducer(categoryReducer, DEFAULT_STATE);
  const {categoryData} = state;
  const [navSelection, setNavSelection] = React.useState('welcome');
  const [categoryName, setCategoryName] = React.useState('welcome');
  const [selApiAttribute, setSelApiAttribute] = React.useState('welcome');
  const [categoryStatus, setCategoryStatus] = React.useState();
  const [disableBar, setDisableBar] = React.useState(false);
  const [pageDirty, setPageDirty] = React.useState('N'); //apcp only
  const [whatsnew, setWhatsnew] = React.useState('');
  const [whatsnewversion, setWhatsnewversion] = React.useState();
  const [displayNew, setDisplayNew] = React.useState(true);
  const [alertMsg, setAlertMsg] = React.useState('');

  // used for generating ids needed for module page
  const len = (window.location.href).split("/").length || 0;
  const org_id = (window.location.href).split("/")[len-4] || 0;
  const org_rol = (window.location.href).split("/")[len-1] || 0;

  React.useEffect(() => {
    let mount = true;

    const fetchData = async () => {
      try {
        let categdata = {data:{data:[]}};
        if(newroles[0]!==EM_ROLE){//skip if EM
          categdata = await getCategory(org_id);
        }
        const resultR = await getReminderDescription();
        await updateFeatureFlag(FeatureFlags.mediauploadpage, dispatch, featureFlagStatus);
        dispatch({type: 'UPDATE_REMINDER', payload: resultR.data.data});//One less api call
        if(mount){
          if(categdata && categdata.data) {
            setLoading(true);
            const catearr = categdata.data.data;
            const sortedData = catearr?.sort((a, b) => a.sequence < b.sequence ? -1 : 1);
            dispatcher({type: "GET_CATEGORY_DATA", payload: sortedData});
          } 
          const whatsnewcontext = resultR.data.data?.filter(e=>e.code==CATEGORY_REMINDER);
          setWhatsnew(marked(whatsnewcontext[0]?.value));
          const incomingversion = whatsnewcontext[0]?.version?whatsnewcontext[0].version:-1;
          setWhatsnewversion(incomingversion);

          const versionstored = localStorage.getItem('whatsnewversion');
          if(parseInt(versionstored)===incomingversion){
            const closed = localStorage.getItem('whatsnewclosed');
            setDisplayNew(closed==='true'?false:true);
          }
          else{
            setDisplayNew(true);
          }
        }
      } catch (err) {
        dispatcher({type: "ERROR", payload: err});
      }
    };
    if(mount){
      fetchData();
    }
    return() => {
      mount = false;
    };
  }, [ org_id]);

  React.useEffect(() => {
    let isCurrent = true;
    if(isCurrent) {
      onLegalNoticeRedirect(org_id);
    }
    return()=> {
      isCurrent=false;
    };
  }, [org_id]);
  
  React.useEffect(()=>{
    const applicationDataLayer = {page:{pageCode: "college-dashboard"}};
    if(typeof kiwi !== "undefined") kiwi.mergeDdl(applicationDataLayer);
    if(typeof _satellite !== "undefined") _satellite.track("cbTrack.viewInDom");
  },[]);
  
  // Used for bfcp live flag
  React.useEffect(() => reminderData?.forEach(el => {
    if(el.code===BFCP_LIVE) {
        set_BCFP_LIVE(`${el.value}`);
    }
    if(el.code===BFCP_HE_LOCK) {
      set_BCFP_HE_LOCK(`${el.value}`);
      dispatch({type: "BFCP_HE_LOCK_DESCRIPTION", payload: `${el.description}`});
    }
    if(el.code===ANNOUNCEMENT){
      setAlertMsg(el.value.trim());
    }
    return;
  }), [dispatch, reminderData]);

  const orgName = orgData?.find(el=> parseInt(el.org_id) === parseInt(org_id))?.org_name;
  const dataCollectionTypes = orgData?.find(el=> parseInt(el.org_id) === parseInt(org_id))?.data_collection_types;

  const onLegalNoticeRedirect = id => {
    const res = orgData?.find(el=> parseInt(el.org_id) === parseInt(id));
    if(res===undefined&&orgData.length===0) {
      return;
    }
    const {is_legal_notice} = res;
    if((is_legal_notice===false || is_legal_notice===null) && newroles[0]!==ADMIN_ROLE) {
      if(metaDataAboutUser.legalNotice === true) {
        return;
      } else {
        return navigate("/bfcp-legalnotice");
      }
    } else {
      return;
    }
  };

  const onCloseWhatsNew = () =>{
    setDisplayNew(false);
    localStorage.setItem("whatsnewversion", whatsnewversion);
    localStorage.setItem("whatsnewclosed", 'true');
  };
  //--main function
  const mainFunction = () => (
    <div style={{marginBottom: "20px"}}>      
    {displayNew===true?
      <WhatsNewModal message={whatsnew} onClose={onCloseWhatsNew} />
    :
    <>
      {newroles[0]!==EM_ROLE&&alertMsg!==''?<AlertBar alertMsg={marked(alertMsg)} />:<></>}
      <div className='cb-band cb-band-hero cb-band-hero-bg bandContainer' id='banddiv'>
        <div role='region' aria-label='Instutional Information' className='cb-band-hero-content cb-white-color' style={{padding:'30px'}}>
              <div style={{display:'flex', alignItems:'baseline', paddingLeft:'20px'}}><h1 id='metadaOrgname'>{orgName}</h1>
              <a href='/' style={{marginLeft:'20px'}}>Switch institution</a>
              </div>
        </div>
      </div>
      <div style={{display:'flex', alignItems: 'top'}}>
      <SideBar categoryData={categoryData} setNavSelection={setNavSelection} navSelection={navSelection}
      setCategoryName={setCategoryName} setCategoryStatus={setCategoryStatus}
      selApiAttribute={selApiAttribute} setSelApiAttribute={setSelApiAttribute}
      pageDirty={pageDirty} disable={disableBar} roles={newroles}/> 

      <RightPanel categoryName={categoryName} org_id={org_id} cat_id={navSelection} 
                  selApiAttribute={selApiAttribute}
                  status={categoryStatus} org_rol={org_rol} cateTooltip={""} 
                  categoryData={categoryData}
                  catDispatcher={dispatcher}
                  setCategoryStatus={setCategoryStatus}
                  setPageDirty={setPageDirty}
                  setDisableBar={setDisableBar}
                  setNavSelection={setNavSelection}
                  setSelApiAttribute={setSelApiAttribute}
                  setCategoryName={setCategoryName}
                  dataCollectionTypes={dataCollectionTypes}
                  />
      <ProcessModal />
      </div>
    </>}
    </div>
  );

  // ---REDIRECT WHEN LIVE
  //--'false' means we are not live so BLOCK OUR APP
  if(is_BCFP_LIVE==="false" && ADMIN_ROLE===org_rol) {
    navigate('/bfcp_is_ready_comingsoon');
  }
  //CHECK if bfcp_lock is true
  if(is_BCFP_HE_LOCK==="true" && ADMIN_ROLE!==org_rol) {
    navigate('/bfcp_he_lock');
  }
  return(
    <div className='mycb-categorypage' data-testid='category_id'>
      {
        !loading?
          <div className='centerEllipsis'><AnimatedEllipsis /></div>
          :
          mainFunction()
      }
    </div>
  );
};
export default CategoryPage;